import React, { createContext, useContext } from 'react';

/* ========================================================================= */
/* Context(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').PageContext} */
const PageContext = createContext({});

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const usePage = () => {
    const context = useContext(PageContext);

    if (context === undefined) {
        throw new Error('usePage must be used within a PageProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').PageContextProvider} */
const PageProvider = ({ page, children }) => {
    return (
        <PageContext.Provider value={{
            page
        }}>
            {children}
        </PageContext.Provider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

PageContext.displayName = 'PageContext';

export {
    PageProvider,
    usePage
};
